import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CallPlanContactsResponse {
  total: number;
  call_plan_contacts: any[];
}

@Injectable({ providedIn: 'root' })
export class SigninCallPlanContactService {
  private http = inject(HttpClient);

  list(
    companyId: string | number,
    apiParams: Record<string, any> = {}
  ): Observable<CallPlanContactsResponse> {
    const url = `${environment.apiUrl}/api/companies/${companyId}/call_plan_contacts`;
    return this.http.get<CallPlanContactsResponse>(url, {
      params: this.toHttpParams(apiParams),
    });
  }

  private toHttpParams(obj: Record<string, any>): HttpParams {
    let params = new HttpParams();
    for (const key of Object.keys(obj)) {
      const val = obj[key];
      if (val !== null && val !== undefined && val !== '') {
        params = params.append(key, String(val));
      }
    }
    return params;
  }
}
